/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'glyph/16/small-triangle-up': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13 11L8 5l-5 6z" _fill="#272c33"/>'
  }
})
